import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sass-one-services',
  templateUrl: './sass-one-services.component.html',
  styleUrls: ['./sass-one-services.component.scss']
})
export class SassOneServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
